export default __webpack_public_path__ + "static/media/Group_learning.3eb8c036.svg";